import { useTranslation } from 'react-i18next';

import { IChannel } from '@/entities/channel';
import { useMaxPersonalDisconnect } from '@/features/channels';
import { useGetConfirmation } from '@/shared/ui/Confirmations/confirmation';
import { Button } from '@/shared/ui/lib/Button';
import { useNotifications } from '@/shared/ui/Notifications';

type TDeleteMaxPersonalConnectionButtonProps = {
  channel: Pick<IChannel, 'id'>;
};

export const DeleteMaxPersonalConnectionButton = ({
  channel,
}: TDeleteMaxPersonalConnectionButtonProps) => {
  const { t } = useTranslation();
  const { getConfirmation } = useGetConfirmation();
  const { addNotification } = useNotifications();
  const { disconnect, isPending } = useMaxPersonalDisconnect();

  const handleDeleteConnection = async () => {
    const isConfirmed = await getConfirmation({
      title: t('channels:settings.deleteConnectionDialog.title'),
      description: t('channels:settings.deleteConnectionDialog.description'),
      confirmText: t('channels:settings.deleteConnectionDialog.confirm'),
      shouldCloseOnConfirm: true,
      priorityButton: 'confirm',
    });

    if (!isConfirmed) return;

    await disconnect(channel.id, () => {
      addNotification({
        type: 'success',
        title: t('channels:settings.deleteConnectionDialog.successDeleted'),
      });
    });
  };

  return (
    <Button
      variant="text"
      color="error"
      loading={isPending}
      onClick={handleDeleteConnection}
    >
      {t('channels:settings.deleteConnection')}
    </Button>
  );
};
